import React from 'react';
import style from './style.module.css';

const DEFAULT_PDF_URL = process.env.REACT_APP_PORTFOLIO_PDF_URL || encodeURI(`${process.env.PUBLIC_URL || ''}/Outstandly Portfolio 2023.pdf`);

const PortfolioChatbot = ({ className = '', portfolioPdfUrl = DEFAULT_PDF_URL }) => {
	const onRequestQuote = () => {
		window.location.href = 'mailto:cellardoor@outstandly.com?subject=Game%20Art%20Quote%20Request';
	};

	const onOpenPortfolio = () => {
		window.open(portfolioPdfUrl, '_blank', 'noopener,noreferrer');
	};

	const actions = [
		{ id: 'quote', label: 'Get a quote', onClick: onRequestQuote },
		{ id: 'portfolio', label: 'Get our Portfolio PDF', onClick: onOpenPortfolio },
	];

	return (
		<div className={`${style.chatShell} ${className}`}>
			<div aria-hidden="true" className={style.powerField}>
				<span className={style.powerCore}></span>
				<span className={style.powerRing}></span>
				<span className={style.powerMist}></span>
			</div>
			<div className={style.actionsStage}>
				<div className={style.optionsGrid}>
					{actions.map((action) => (
						<button
							type="button"
							key={action.id}
							className={style.optionButton}
							onClick={action.onClick}
						>
							<span className={style.optionText} data-text={action.label}>
								{action.label}
							</span>
							<span aria-hidden="true" className={style.optionScan}></span>
						</button>
					))}
				</div>
			</div>
			<div className={style.footerNote}>
				<p className={style.footerLine}>
					For any other questions, specific portfolio samples <span className={style.footerSubcopy}>(we&apos;ve done a lot over the past 10 years)</span> or <s>threats</s>,
				</p>
				<p className={style.footerLine}>
					please email us at <a className={style.footerLink} href="mailto:cellardoor@outstandly.com">cellardoor@outstandly.com</a>
				</p>
			</div>
		</div>
	);
};

export default PortfolioChatbot;
